import axios from 'axios'
import store from '@/store'
import NProgress from 'nprogress'

//  Base HTTP
const $baseHTTP = axios.create({
  baseURL: `${process.env.DATA_API_PATH}`,
  headers: {
    Accept: 'application/json',
  },
})

function handleError(error) {
  const errorMessage = error
                      && error.response
                      && error.response
                      && error.response.data
                      && error.response.data.type
                      && i18nErrors[error.response.data.type]
    ? i18nErrors[error.response.data.type]
    : 'Произошла ошибка'
  console.log(error.response ? error.response : error)
  store.commit('task/set', { type: 'submitMode', value: false })
  store.dispatch('tools/setSnackbar', errorMessage)
  throw error
}

$baseHTTP.interceptors.request.use((cfg) => {
  NProgress.start()
  store.dispatch('tools/setLoading', true)
  return cfg
}, (error) => {
  NProgress.done()
  store.dispatch('tools/setLoading', false)
  return Promise.reject(error)
})

$baseHTTP.interceptors.response.use((cfg) => {
  NProgress.done()
  store.dispatch('tools/setLoading', false)
  return cfg
// eslint-disable-next-line consistent-return
}, (error) => {
  NProgress.done()
  store.dispatch('tools/setLoading', false)
  return Promise.reject(error)
})

const api = {
  employee: {
    iin(iin) {
      return $baseHTTP.get(`employee?iin=eq.${iin}`).catch((error) => { handleError(error) });
    },
    tabNo(tabNo) {
      return $baseHTTP.get(`employee?corporate_id=eq.${tabNo}`).catch((error) => { handleError(error) });
    },
    fioLike(fioText) {
      return $baseHTTP.get(`employee?name=like.${fioText}*`).catch((error) => { handleError(error) });
    },
    workPlaceEmployees(workPlaceId) {
      return $baseHTTP.get(`employee?data->workPlace->>id=eq.${workPlaceId}`).catch((error) => { handleError(error) });
    },
  },
  recreationCenter: {
    fetchAll(){
      return $baseHTTP.get(`recreation_center`).catch((error) => { handleError(error) });
    },
    fetchFound(data){
      return $baseHTTP.get(`recreation_center_view?region=eq.${data.region}&work_place=eq.${data.workPlace}`).catch((error) => { handleError(error) });
    },
    fetchCategories(recreation_center_id, region, workPlace) {
      return $baseHTTP.get(
        `current_year_recreation_center_categories?` +
        `recreation_center_id=eq.${recreation_center_id}&` +
        `region=eq.${region}&` +
        `work_place=like.*${workPlace}*`
      ).catch((error) => { handleError(error) });
    },
    fetchCategoriesNew(recreation_center_id, region, workPlace, structuralUnit) {
      return $baseHTTP.get(
        `rpc/get_recreation_center_categories?` +
        `p_recreation_center_id=${recreation_center_id}&` +
        `p_region=${region}&` +
        `p_work_place=${workPlace}&` +
        `p_structural_unit=${structuralUnit}`
      )
    },
    fetchDays(categoryId, year, status){
      return $baseHTTP.get(`recreation_center_days?category=eq.${categoryId}&year=eq.${year}&status=eq.${status}`).catch((error) => { handleError(error) });
    },
    getRecreationCenterDayStatus(id){
      return $baseHTTP.get(`recreation_center_days?id=eq.${id}`).catch((error) => { handleError(error) });
    },
  },
  spaTreatment: {
    fetchAll(){
      return $baseHTTP.get(`spa_treatment`).catch((error) => { handleError(error) });
    },
    fetchCategories(spa_treatment_id, region, workPlace){
      return $baseHTTP.get(`spa_treatment_category?spa_treatment_id=eq.${spa_treatment_id}&region=eq.${region}&work_place=eq.${workPlace}`).catch((error) => { handleError(error) });
    },
    fetchDays(categoryId, year, status){
      return $baseHTTP.get(`spa_treatment_days?category=eq.${categoryId}&year=eq.${year}&status=eq.${status}`).catch((error) => { handleError(error) });
    },
    getSpaTreatmentDayStatus(id){
      return $baseHTTP.get(`spa_treatment_days?id=eq.${id}`).catch((error) => { handleError(error) });
    },
  },
  dispensary: {
    fetchAll(){
      return $baseHTTP.get(`dispensary`).catch((error) => { handleError(error) });
    },
    fetchCategories(dispensary_id, region, workPlace){
      return $baseHTTP.get(`dispensary_category?dispensary_id=eq.${dispensary_id}&region=eq.${region}&work_place=eq.${workPlace}`).catch((error) => { handleError(error) });
    },
    fetchDays(categoryId, year, status){
      return $baseHTTP.get(`dispensary_days?category=eq.${categoryId}&year=eq.${year}&status=eq.${status}`).catch((error) => { handleError(error) });
    },
    getDispensaryDayStatus(id){
      return $baseHTTP.get(`dispensary_days?id=eq.${id}`).catch((error) => { handleError(error) });
    },
  },
  summerHealthCamp: {
    fetchAll(){
      return $baseHTTP.get(`summer_health_camp`).catch((error) => { handleError(error) });
    },
    fetchCategories(summer_health_camp_id, region, workPlace){
      return $baseHTTP.get(`current_year_summer_health_camp_categories?summer_health_camp_id=eq.${summer_health_camp_id}&region=eq.${region}&work_place=eq.${workPlace}`).catch((error) => { handleError(error) });
    },
    fetchDays(summerHealthCampId, year, categoriesListIds, status){
      return $baseHTTP.get(`summer_health_camp_days?summer_health_camp=eq.${summerHealthCampId}&year=eq.${year}&category=in.(${categoriesListIds})&status=eq.${status}`).catch((error) => { handleError(error) });
    },
    getSummerHealthCampDayStatus(id){
      return $baseHTTP.get(`summer_health_camp_days?id=eq.${id}`).catch((error) => { handleError(error) });
    },
  }
}

export default api



// WEBPACK FOOTER //
// ./src/services/data-api.js